/**
 * Convite de família pendente, na faixa de alerta da Home (PO, 19/09/2026):
 * "[nome] te convidou para a [família]. Aceite e faça parte." Antes só quem
 * abria o Grupo via o convite. Tocar leva ao Grupo, onde se aceita ou recusa.
 */
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { readGrupo } from './api';

export function ConviteDeFamiliaNaHome() {
  const navigate = useNavigate();
  const { tripId, members } = useTrip();
  const grupo = useQuery({
    queryKey: ['grupo', tripId],
    queryFn: () => readGrupo(tripId),
    enabled: tripId.length > 0 && members.length >= 2,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
  const convite = grupo.data?.pendingInvitations[0];
  if (!convite) return null;
  return (
    <button type="button" className="home-alerta home-alerta--familia" onClick={() => navigate('/grupo')} data-testid="home-alerta-familia">
      <span className="home-alerta__icone" aria-hidden="true"><Icon name="pessoas" size={18} /></span>
      <span className="home-alerta__texto">
        <b>{convite.invitedByName ?? 'Alguém'}</b> te convidou para a <b>{convite.familyName}</b>. Aceite e faça parte.
      </span>
      <Icon name="avancar" size={16} />
    </button>
  );
}
